var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6570\u636E\u7EDF\u8BA1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F1A\\u6240\\u7CFB\\u7EDFUI\\u754C\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6570\\u636E\\u7EDF\\u8BA1/\\u8FD0\\u8425\\u6570\\u636E",
    transform: "translate(-1328.000000, -83.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pageheader\\u5907\\u4EFD",
    transform: "translate(208.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3\\u5907\\u4EFD-4",
    transform: "translate(1108.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6570\\u636E\\u7EDF\\u8BA1",
    transform: "translate(12.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L16,0 L16,16 L0,16 L0,0 Z",
    id: "root.list-(Background)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L16,0 L16,16 L0,16 L0,0 Z",
    id: "\\u77E9\\u5F62",
    opacity: 0.0000999999975
  }), /*#__PURE__*/React.createElement("g", {
    id: "tj/icon",
    fill: "currentColor",
    fillOpacity: 0.9,
    fillRule: "nonzero",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "he_61shujutongji",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5871404,5 C10.3637902,5 10.1810491,4.8125 10.1810491,4.58333333 L10.1878173,0.416666667 C10.1878173,0.1875 10.3705584,0 10.5939086,0 C10.8172589,0 11,0.1875 11,0.416666667 L10.9932318,4.58333333 C10.9932318,4.8125 10.8104907,5 10.5871404,5 Z M8.99661591,4.99305556 C8.77326565,4.99305556 8.59052453,4.80555556 8.59052453,4.57638889 L8.59729272,1.45138889 C8.59729272,1.22222222 8.78003384,1.03472222 9.00338409,1.03472222 C9.22673435,1.03472222 9.40947547,1.22222222 9.40947547,1.45138889 L9.40270728,4.57638889 C9.40270728,4.80555556 9.21996616,4.99305556 8.99661591,4.99305556 Z M7.40609137,4.99305556 C7.18274112,4.99305556 7,4.80555556 7,4.57638889 L7.00676819,2.49305556 C7.00676819,2.26388889 7.18950931,2.07638889 7.41285956,2.07638889 C7.63620981,2.07638889 7.81895093,2.26388889 7.81895093,2.49305556 L7.81218274,4.57638889 C7.81218274,4.80555556 7.62944162,4.99305556 7.40609137,4.99305556 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00348903,12 C2.69001142,12 0,9.31015131 0,5.99687414 C0,2.76765474 2.52188571,0.13384456 5.75130046,0.000753088332 C5.86338427,-0.00625172598 5.97546808,0.0357771599 6.05953093,0.119834932 C6.14359379,0.196887889 6.18562522,0.308964918 6.18562522,0.421041947 L6.18562522,5.45750344 L11.5796585,5.45750344 C11.8038262,5.45750344 11.9859623,5.63262379 11.9999864,5.84977304 L11.9999864,5.99687414 C12.0069781,9.30314649 9.3099614,12 6.00348903,12 Z M5.34499665,0.876354877 C2.78808475,1.19857634 0.840628569,3.37006877 0.840628569,5.99687414 C0.840628569,8.84082875 3.15936237,11.1594223 6.00348903,11.1594223 C8.74954235,11.1594223 10.9982238,9.00193948 11.1593443,6.29808115 L5.76531094,6.29808115 C5.53413808,6.29808115 5.34499665,6.10895117 5.34499665,5.87779229 L5.34499665,0.876354877 Z",
    id: "\\u5F62\\u72B6"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.646093be2c8a22c1f30aceeaa8dd1cf1.svg";
export { ForwardRef as ReactComponent };